/**
 * A thin bar for a percent. At or over `full` it turns ink and its number goes bold: something to look at, not an
 * outage (admin-design-r1 question 4: full meters use ink, Signal stays for down). With a `caption` it lays out as a
 * row: caption, bar, number.
 */
import { cx } from '../cx'
import s from './Meter.module.css'

export function Meter({ value, label, full, caption }: { value: number; /** Announced as a meter with this name. */ label?: string; full?: number; /** "mem", "disk": draws the row with the number. */ caption?: string }) {
  const pct = Math.max(0, Math.min(100, value))
  const isFull = full !== undefined && pct >= full
  const bar = (
    <div
      className={cx(s.meter, isFull && s.full)}
      {...(label ? { role: 'meter', 'aria-label': label, 'aria-valuenow': Math.round(pct), 'aria-valuemin': 0, 'aria-valuemax': 100 } : { 'aria-hidden': true })}
    >
      <i style={{ width: `${pct}%` }} />
    </div>
  )
  if (!caption) return bar
  return (
    <div className={cx(s.row, isFull && s.rowFull)}>
      <span className={s.cap}>{caption}</span>
      {bar}
      <span className={s.num}>{Math.round(pct)}%</span>
    </div>
  )
}
